// Generic filters type shared across observatory filtering components
export type Filters<TToggle extends string = string, TSort extends string = string> = {
  toggles: Record<TToggle, boolean>
  sortOn: TSort
  sortDirection?: 'asc' | 'desc'
}

export const ASSET_FILTER_TOGGLES = {
  PTU: true,
  'My Assets': true,
  'Shared With Me': true,
  'Offline Only': false,
} as const
export type AssetFilterToggleKey = keyof typeof ASSET_FILTER_TOGGLES

export const ASSET_SORT_OPTIONS = [
  'Alphabetically',
  'Date Created',
  'Recently Active',
  'Alphabetical Active',
] as const
export type AssetSortOption = (typeof ASSET_SORT_OPTIONS)[number]

export type AssetFilters = Filters<AssetFilterToggleKey, AssetSortOption>

export type FilterAction<TToggle extends string, TSort extends string> =
  | { type: 'TOGGLE_FILTER'; filter: TToggle }
  | { type: 'SORT'; sortOn?: TSort }
  | { type: 'DIRECTION'; direction?: 'asc' | 'desc' }

export type SearchSectionProps<TToggle extends string = string, TSort extends string = string> = {
  search?: string
  onSearchChanged?: (search: string) => void
  filters?: Filters<TToggle, TSort>
  onFilterChanged?: (filters: Filters<TToggle, TSort>) => void
  sortOptions?: readonly TSort[] | TSort[]
}

export const GEOFENCE_FILTER_TOGGLES = {} as const
export type GeoFenceFilterToggleKey = keyof typeof GEOFENCE_FILTER_TOGGLES

export const GEOFENCE_SORT_OPTIONS = [
  'High-Risk',
  'Recently Active',
  'Date Modified',
  'Alphabetically',
] as const
export type GeoFenceSortOption = (typeof GEOFENCE_SORT_OPTIONS)[number] | 'Date Created'

export type GeoFenceFilters = Filters<GeoFenceFilterToggleKey, GeoFenceSortOption>
